import { render, staticRenderFns } from "./student-seat.vue?vue&type=template&id=616a93d0&scoped=true&"
import script from "./student-seat.vue?vue&type=script&lang=js&"
export * from "./student-seat.vue?vue&type=script&lang=js&"
import style0 from "./student-seat.vue?vue&type=style&index=0&id=616a93d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a93d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
